import CallManageIndexComponent from './component';

class CallManageIndexRoute extends CallManageIndexComponent {

}

export default CallManageIndexRoute;
